import React, { FC } from 'react';

const IconBack: FC = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
      <polygon
        fillRule="evenodd"
        points="8.388 0 .667 8 8.388 16 9.084 15.278 2.525 8.482 16 8.482 16 7.461 2.58 7.461 9.084 .721"
      />
    </svg>
  );
};

export default IconBack;
